import formatBoolean from './formatBoolean';
import formatCardType from './formatCardType';
import formatCellphone from './formatCellphone';
import formatCurrency from './formatCurrency';
import formatDate from './formatDate';
import formatDateTime from './formatDateTime';
import formatPercentage from './formatPercentage';

export default {
  install(Vue) {
    Vue.filter('formatBoolean', formatBoolean);
    Vue.filter('formatCardType', formatCardType);
    Vue.filter('formatCellphone', formatCellphone);
    Vue.filter('formatCurrency', formatCurrency);
    Vue.filter('formatDate', formatDate);
    Vue.filter('formatDateTime', formatDateTime);
    Vue.filter('formatPercentage', formatPercentage);
  },
};
